import { useLayoutEffect, useRef } from "react";
import { ToolbarGroup } from "../components/Toolbar";

type Props = {
  rootRef: React.RefObject<HTMLDivElement>;
  toolbarGroups: ToolbarGroup[];
  setMainButtons: React.Dispatch<React.SetStateAction<ToolbarGroup[]>>;
  setOverflowButtons: React.Dispatch<React.SetStateAction<ToolbarGroup[]>>;
};

export default function useEditorToolbarLayout({
  rootRef,
  toolbarGroups,
  setMainButtons,
  setOverflowButtons,
}: Props) {
  const resizeObserverRef = useRef<ResizeObserver | null>(null);

  useLayoutEffect(() => {
    const node = rootRef.current;
    if (!node) return;

    const handleResize = (entry: ResizeObserverEntry) => {
      const width = entry.contentRect.width;
      if (width < 480) {
        setMainButtons(toolbarGroups.slice(0, 1));
        setOverflowButtons(toolbarGroups.slice(1));
      } else if (width < 600) {
        setMainButtons(toolbarGroups.slice(0, 2));
        setOverflowButtons(toolbarGroups.slice(2));
      } else if (width < 700) {
        setMainButtons(toolbarGroups.slice(0, 3));
        setOverflowButtons(toolbarGroups.slice(3));
      } else {
        setMainButtons(toolbarGroups);
        setOverflowButtons([]);
      }
    };

    const observer = new ResizeObserver(([entry]) => {
      if (entry) handleResize(entry);
    });
    observer.observe(node);
    resizeObserverRef.current = observer;

    return () => {
      observer.disconnect();
    };
  }, [rootRef, toolbarGroups, setMainButtons, setOverflowButtons]);
}
